module.exports = __webpack_public_path__ + "img/dnc_studio.7265ed3c.png";